import { useEffect, useState } from "react";
import useAuth from "@/hooks/useAuth";
import usersApi from "@/api/usersApi";
import UserProfileResponse from "@/model/UserProfileResponse";

/** Loads the signed-in user's profile (e.g. to find a host's own companyId). */
function useCurrentUser() {
  const { session } = useAuth();
  const [user, setUser] = useState<UserProfileResponse | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!session) {
      return;
    }

    let cancelled = false;
    setIsLoading(true);
    setError(false);

    usersApi
      .getCurrentUser(session.accessToken)
      .then((result) => {
        if (!cancelled) {
          setUser(result);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setError(true);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setIsLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [session]);

  return { user, isLoading, error };
}

export default useCurrentUser;
